import { usePlanType } from "./use-plan-type";
import { useIsAdmin } from "./use-user-role";

/**
 * Hook to check if the current user has access to Facility features.
 * Returns true if user has 'zoo' or 'sanctuary' plan, or is an admin.
 */
export const useFacilityAccess = () => {
  const { data: planType, isLoading: planLoading } = usePlanType();
  const { isAdmin, isSiteAdmin, isLoading: adminLoading } = useIsAdmin();

  return {
    hasFacilityAccess: planType === 'zoo' || planType === 'sanctuary' || isAdmin || isSiteAdmin,
    isLoading: planLoading || adminLoading,
  };
};
